import { Button, Text } from '@axilon-apps/libs-ui-shadcn'
import { Plus } from 'lucide-react'
import { useToggle } from '@axilon-apps/libs-ui-components'
import { usePermissions } from '@axilon-apps/domains-identity/state'
import { IdentityAction } from '@axilon-apps/domains-identity/constants'

import CreateUserModal from '../CreateUserModal/CreateUserModal'

interface Props {
  showEmail: boolean
}

const UsersPageHeader = ({ showEmail }: Props) => {
  const { isOpen, open, close } = useToggle()
  const { can } = usePermissions()

  return (
    <>
      <div className="flex flex-col items-center gap-6 sm:flex-row">
        <div className="flex flex-1 flex-col gap-2">
          <Text variant="h1" as="h1">
            User Management
          </Text>
        </div>
        <div className="flex flex-row items-center gap-4">
          {can(IdentityAction.Users.Create) && (
            <Button onClick={open}>
              <Plus className="size-4" />
              Create
            </Button>
          )}
        </div>
      </div>
      {isOpen && <CreateUserModal isOpen={isOpen} close={close} showEmail={showEmail} />}
    </>
  )
}

export default UsersPageHeader
